/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, TextInput } from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { useEffect, useState } from "react";
import {
  UpdateTemplateInput,
  UpdateTemplateMutation,
  UpdateTemplateMutationVariables
} from "../../API";
import { updateTemplate } from "../../graphql/mutations";
const client = generateClient();
type editPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  setModalConfirmDeleteOpened: (value: boolean) => void;
  template: any;
  setTemplate: (value: any) => void;
  fetchTemplates: () => void;
};

const EditTemplateModal = (props: editPatientProps) => {
  const {
    modalOpened,
    setModalOpened,
    template,
    setModalConfirmDeleteOpened,
    fetchTemplates
  } = props;

  const [loading, setLoading] = useState(false);
  const [templateName, setTemplateName] = useState("");
  useEffect(() => {
    setTemplateName(template?.name);
  }, [template]);
  const handleEditTemplate = async () => {
    setLoading(true);
    try {
      // Use your GraphQL client to make a mutation call
      const updateTemplateInput: UpdateTemplateInput = {
        id: template.id,
        _version: template._version,
        name: templateName
      };
      const updateTemplateVars: UpdateTemplateMutationVariables = {
        input: updateTemplateInput
      };

      const updateSectionResult = await client.graphql<
        GraphQLQuery<UpdateTemplateMutation>
      >({ query: updateTemplate, variables: updateTemplateVars });
      console.log(updateSectionResult);
    } catch (err) {
      console.log("error updating template:", err);
    }
    fetchTemplates();
    setLoading(false);
    setModalOpened(false);
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => setModalOpened(false)}
      title="Edit template"
    >
      <TextInput
        label="Name"
        placeholder="Enter template name"
        value={templateName}
        onChange={(event) => setTemplateName(event.target.value)}
      />
      <Group mt="md">
        <Group mt="md">
          <Button onClick={handleEditTemplate} loading={loading}>
            Save
          </Button>
          <Button
            color="red"
            onClick={() => {
              setModalOpened(false);
              setModalConfirmDeleteOpened(true);
            }}
          >
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default EditTemplateModal;
